import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=1b42a9a7&scoped=true&"
import script from "./CommentDetail.vue?vue&type=script&lang=js&"
export * from "./CommentDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommentDetail.vue?vue&type=style&index=0&id=1b42a9a7&prod&lang=less&scoped=true&"
import style1 from "./CommentDetail.vue?vue&type=style&index=1&id=1b42a9a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42a9a7",
  null
  
)

export default component.exports